import { BehaviorSubject } from "rxjs";

//Login subscriber initial state
const loginSubscriber = new BehaviorSubject(false);

//Message service that allows components to notify subscribers of subscriber state change
const loginMessageService = {
    send: (msg) => {
        loginSubscriber.next(msg);
    },
};

export { loginSubscriber, loginMessageService };
